export default [
    {
        title: "Orders",
        icon: "CalendarIcon",
        route: "order-list",
        action: "read",
        resource: "pcp"
    },
    {
        title: "Production Progress",
        icon: "TrendingUpIcon",
        route: "production-progress",
        action: "read",
        resource: "pcp"
    },
    {
        title: "Dashboards",
        icon: "ActivityIcon",
        children: [
            {
                title: "OEE",
                route: "dashboard-oee",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            },
            {
                title: "Hora Homem",
                route: "dashboard-man-hour",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            },
            {
                title: "Qualidade",
                route: "dashboard-quality",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            },
            {
                title: "Paradas",
                route: "dashboard-stops",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            },
            {
                title: "Ocupação de Recursos",
                route: "dashboard-resource-occupation",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            },
            {
                title: "Análise de Produção",
                route: "production-analysis",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            }
        ]
    },
    {
        title: "System Setting",
        icon: "SettingsIcon",
        children: [
            {
                title: "WorkCenters",
                route: "workcenters",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            },
            {
                title: "Classification",
                icon: "ChevronRightIcon",
                children: [
                    {
                        title: "Refuse Status",
                        route: "refuse-status",
                        icon: "ChevronRightIcon",
                        action: "read",
                        resource: "pcp"
                    },
                    {
                        title: "Resource Status",
                        route: "resource-status",
                        icon: "ChevronRightIcon",
                        action: "read",
                        resource: "pcp"
                    }
                ]
            },
            {
                title: "Resources",
                route: "resources",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            },
            {
                title: "Sites",
                route: "sites",
                icon: "ChevronRightIcon",
                action: "read",
                resource: "pcp"
            }
        ]
    }
];
